module.exports = __webpack_public_path__ + "img/23.36f02a72.png";